import Icon from '@atoms/Icon/Icon';
import { IRelatedLink } from '@models/IRelatedLink';

const RelatedLinkCard = ({
  name,
  description,
  url,
  target,
  dataTestId = 'CT-38-Related-Links-Navigation-Card',
}: IRelatedLink) => (
  <a
    className="mb-4 flex rounded-md border border-grey py-6 pr-9 pl-8 outline outline-2 outline-white hover:border-white hover:outline-yellow focus:border-white focus:outline-yellow"
    key={`link-${name}-${url}`}
    href={url}
    target={target}
    data-testid={`${dataTestId}-Link`}
  >
    <div className="flex flex-col justify-center lg:mr-5">
      {name && (
        <p
          className="body-one font-light text-black-100"
          data-testid={`${dataTestId}-Name`}
        >
          {name}
        </p>
      )}
      {description && (
        <p
          className="body-one font-light text-grey-450 md:hidden xl:block"
          data-testid={`${dataTestId}-Text`}
        >
          {description.length > 85
            ? `${description.substring(0, 85)}...`
            : description}
        </p>
      )}
    </div>
    <div className="ml-auto flex lg:items-center">
      <div className="flex h-13 w-13 items-center justify-center rounded-full bg-yellow">
        <Icon name="east" />
      </div>
    </div>
  </a>
);

export default RelatedLinkCard;
